import React, { ReactNode } from 'react';
import { ManageCvsStore } from './manage-cvs.store';

const ManageCvsContext = React.createContext<ManageCvsStore | null>(null);

export const ManageCvsProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<ManageCvsStore>(() => new ManageCvsStore());

   return <ManageCvsContext.Provider value={store}>{children}</ManageCvsContext.Provider>;
};

export const useManageCvs = () => {
   const ctx = React.useContext(ManageCvsContext);
   if (!ctx) {
      throw new Error('useManageCvs must be used inside  ManageCvsProvider');
   }
   return ctx;
};
